
export enum InvoiceSendStatusCd {
	EXPIRED = 'Expired',
	HOLD = 'Hold',
	NEW = 'New',
	PAID = 'Paid',
	READY = 'Ready',
	SENT = 'Sent'}

